const config = {
    apiBaseUrl: 'https://dodigitals.in/dodigitalscard/public/api/'
  };
  
  export default config;